import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link, history, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Row,
  Col
} from "reactstrap";
import FontAwesome from "react-fontawesome";
import { getCloudImageUrl } from "../../../utils/Helpers";
// import promo1 from "../../../images/iklan-mandiri.webp";
// import promo2 from "../../../images/webbanner_flavorzone.jpg";
import { sliderBanner, sliderItemClick } from "../../../actions/slidersAction";
import { getSliderSection } from "../../../actions/kafairAction"
import Analytics from "../../../services/Analytics";
import KickCarousel from "../KickCarousel";
import { API_BASE_URL } from "../../../constants"

class PromoBannerBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageBanner: [],
      activeSlide: 0,
      pause: true
    }
  }

  componentDidMount() {
    this.props.getSliderSection()
      .then(({ value }) => {
        this.setState({
          imageBanner: value.data
        })
      })
      .catch(e => console.log(e))
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.category !== this.props.category) {
  //     this._getSliderBanner();
  //   }
  // }

  _getSliderBanner = async () => {
    const { dataCategory } = this.props;
    const newCategory = dataCategory === "bcaxkickavenue" ? "flash-sale" : dataCategory;
    const params = { params: { category: newCategory } };

    await this.setState({
      activeSlide: 0,
      pause: true
    });

    this.props.sliderBanner(params)
  };

  _handleSliderClick(id) {
    const { dataAuth } = this.props;
    const payload = {
      slider_id: id,
      action: "SLIDER_ITEM_CLICK",
      user_id: dataAuth.isLogged ? dataAuth.userdata.id : null,
      app_os: "Web",
    };

    const sliderProperties = {
      userId: dataAuth.isLogged ? dataAuth.userdata.id : "Anonymous",
      app_os: "Web",
      slider_id: id
    };

    this.props.sliderItemClick(payload);
    Analytics.recordSliders("slider_item_click", sliderProperties);
  }

  renderCarousel = () => {
    const { sliderImages, category, dataAuth } = this.props;
    return (
      <>
        {
          sliderImages.images.length && !sliderImages.error ? (
            <KickCarousel
              activeIndex={this.state.activeSlide}
              pause={this.state.pause}
              sliders={sliderImages.images}
              sliderState={this.state.imageSliders}
              onActiveIndexChanged={index =>
                this.setState({ activeSlide: index })
              }
              dataAuth={dataAuth}
              history={this.props.history}
              onSliderClick={() => this._handleSliderClick()}
            />
          ) : null
        }
      </>
    )
  }

  navigateToPage = item => {

    if (item.includes(".")) {
      return window.open(item, '_newtab');
    } else {
      let url = item.replace(/(http:|)(^|\/\/)(.*?\/)/g, '')
      if (url) {
        window.location.href = url
      }
    }


  }

  render() {
    return (
      <div className="promo-banner-section">
        {
          this.state.imageBanner && this.state.imageBanner.map((item, index) => {
            const isCollection = item.redirect_url.indexOf("collection/")

            return (
              <div onClick={() => this.navigateToPage(item.redirect_url)}>
                <KickImage
                  src={getCloudImageUrl(item.img_url, 5000)}
                  style={{ marginBottom: index == this.state.imageBanner.length - 1 && "0px !important" }}
                />
              </div>
            )
          })
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  sliderImages: state.sliderHome,
  dataAuth: state.dataAuth
});

const mapDispatchToProps = dispatch => ({
  sliderBanner: payload => dispatch(sliderBanner(payload)),
  sliderItemClick: payload => dispatch(sliderItemClick(payload)),
  getSliderSection: params => dispatch(getSliderSection(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PromoBannerBank))
